import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  InjectionToken,
  input,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';
import { asyncScheduler, combineLatest, of, Subscription } from 'rxjs';
import {
  distinctUntilChanged,
  map,
  observeOn,
  startWith,
} from 'rxjs/operators';

import { FormBaseControlComponent } from './form-base-control/form-base-control.component';

export const FORM_BASE_CONTROL_CMP =
  new InjectionToken<FormBaseControlComponent>('formBaseControl');

@Directive({
  selector: '[pluginsFormBaseControlStyle]',
  standalone: true,
})
export class FormBaseControlStyleDirective implements AfterViewInit, OnDestroy {
  private control = inject(NgControl, { host: true, optional: true });
  private formBaseControlCmp = inject(FORM_BASE_CONTROL_CMP);
  private elemRef = inject(ElementRef);
  private renderer = inject(Renderer2);

  readonly borderColor = input('#b0b0b0', {
    alias: 'pluginsFormBaseControlStyleBorderColor',
  });

  private subscription?: Subscription;

  ngAfterViewInit(): void {
    const control = (this.control ??
      this.formBaseControlCmp.control) as FormControl;
    this.subscription = combineLatest([
      this.formBaseControlCmp.focused$,
      control.statusChanges?.pipe(
        startWith(control.status),
        observeOn(asyncScheduler),
        map(() => control.status === 'INVALID' && control.dirty),
      ) ?? of(false),
    ])
      .pipe(
        distinctUntilChanged(
          ([prevFocused, prevInvalid], [currFocused, currInvalid]) =>
            prevFocused === currFocused && prevInvalid === currInvalid,
        ),
      )
      .subscribe(([focused, invalid]) => {
        this.renderer.setStyle(
          this.elemRef.nativeElement,
          'box-shadow',
          focused
            ? invalid
              ? `0 0 0 0.2rem rgba(255, 0, 0, 0.2)`
              : `0 0 0 0.2rem ${this.formBaseControlCmp.focusColor}`
            : 'none',
        );
        this.renderer.setStyle(
          this.elemRef.nativeElement,
          'border-color',
          invalid
            ? 'red'
            : focused
              ? this.formBaseControlCmp.baseColor
              : this.borderColor(),
        );
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
